import { Component, OnInit } from '@angular/core';
import { ChartType } from 'angular-google-charts';
import { PfsService } from 'src/app/services/pfs.service';

@Component({
  selector: 'app-pfs-charts',
  templateUrl: './pfs-charts.component.html'
})
export class PfsChartsComponent implements OnInit {
  chartWidth = 600;

  chartHeight = 400;

  chartType: ChartType = ChartType.PieChart;

  chartDataBySource: any[] = [];
  chartOptionsBySource = { title: 'Holdings by Source' };

  chartDataByType: any[] = [];
  chartOptionsByType = { title: 'Holdings by Type' };

  chartDataByEntity: any[] = [];
  chartTypeByEntity: ChartType = ChartType.ColumnChart;
  chartOptionsByEntity = {
    title: 'Holdings by Entity',
    legend: { position: 'none' },
    hAxis: { title: 'Entity ID' },
    vAxis: { title: 'Total Value' }
  };

  // 3. Bar chart (Holdings by Type)
  chartTypeBar: ChartType = ChartType.BarChart;
  chartDataBar: any[] = [];
  chartOptionsBar = {
    title: 'Bar Chart - Holdings by Type',
    bars: 'horizontal'
  };

  // 4. Line chart (simulated trend)
  chartTypeLine: ChartType = ChartType.LineChart;
  chartDataLine: any[] = [
    ['Date', 'Value'],
    ['2025-06-01', 100000],
    ['2025-06-10', 150000],
    ['2025-06-20', 200000]
  ];
  chartOptionsLine = {
    title: 'Holdings Over Time (Line Chart)',
    curveType: 'function',
    legend: { position: 'bottom' }
  };

  // 5. Area chart
  chartTypeArea: ChartType = ChartType.AreaChart;
  chartDataArea: any[] = [
    ['Date', 'Value'],
    ['2025-06-01', 20000],
    ['2025-06-10', 35000],
    ['2025-06-20', 50000]
  ];
  chartOptionsArea = {
    title: 'Cumulative Holdings (Area Chart)',
    isStacked: true
  };

  // 6. Donut chart
  chartTypeDonut: ChartType = ChartType.PieChart;
  chartDataDonut: any[] = [];
  chartOptionsDonut = {
    title: 'Holdings by Source (Donut)',
    pieHole: 0.4
  };

  // 7. Table chart
  chartTypeTable: ChartType = ChartType.Table;
  chartDataTable: any[] = [];

  chartOptionsTable = {
    showRowNumber: true,
    width: '100%',
    height: '100%'
  };

  // 8. Geo chart (mocked for now)
  chartTypeGeo: ChartType = ChartType.GeoChart;
  chartDataGeo: any[] = [
    ['Country', 'Value'],
    ['United States', 300000],
    ['Switzerland', 150000]
  ];
  chartOptionsGeo = {
    region: 'world',
    colorAxis: { colors: ['#aec6cf', '#034694'] }
  };

  constructor(private pfsService: PfsService) {}

  ngOnInit(): void {
    this.pfsService.getHoldingsByClient(99, null).subscribe(data => {
      this.chartDataBySource = this.groupAndSum(data, 'data_source');
      this.chartDataByType = this.groupAndSum(data, 'type');
      this.chartDataByEntity = this.groupAndSum(data, 'entity_id');

      this.chartDataBar = this.chartDataByType;
      this.chartDataDonut = this.chartDataBySource;
      this.chartDataTable = data.map((d: { name: any; type: any; value: any; }) => [d.name, d.type, d.value]);
    });
  }

  private groupAndSum(data: any[], key: string): any[] {
    const grouped: { [key: string]: number } = {};
    for (const row of data) {
      const k = row[key];
      grouped[k] = (grouped[k] || 0) + row.value;
    }
    return Object.entries(grouped);
  }
}
